import { useState, useEffect } from 'react'
import axios from 'axios'

const MODELS_CACHE_KEY = 'cachedModels'

export function useModels() {
  const [models, setModels] = useState<string[]>([])
  const [selectedModel, setSelectedModel] = useState<string>('')

  useEffect(() => {
    const cached = localStorage.getItem(MODELS_CACHE_KEY)
    if (cached) {
      const names = JSON.parse(cached) as string[]
      setModels(names)
      if (!selectedModel && names.length) setSelectedModel(names[0])
    } else {
      axios
        .get('https://stablehorde.net/api/v2/status/models?type=image&model_state=all')
        .then((r) => {
          const names = r.data.map((m: any) => m.name).sort()
          setModels(names)
          if (!selectedModel && names.length) setSelectedModel(names[0])
          localStorage.setItem(MODELS_CACHE_KEY, JSON.stringify(names))
        })
        .catch(console.error)
    }
  }, [])

  return { models, selectedModel, setSelectedModel }
}
